import fetch from 'cross-fetch'
import Axios from 'axios';
import { browserHistory } from 'react-router';
import { getRequest, postRequest, putRequest } from '../../utils/apiUtils';
var request = require('request');

export const RECEIVE_PENDING_PERIODICALS='RECEIVE_PENDING_PERIODICALS'
export const RECEIVE_SCHEDULE_PERIODICALS='RECEIVE_SCHEDULE_PERIODICALS'
export const PENDING_SCHEDULE_PERIODICALS_UPDATE='PENDING_SCHEDULE_PERIODICALS_UPDATE'
export const SCHEDULE_PERIODICALS_UPDATE='SCHEDULE_PERIODICALS_UPDATE'
export const DRAG_TO_MONTH='DRAG_TO_MONTH'



//* start //
function fetchPendingPeriodicals(id) {
    return async dispatch => {
        return await getRequest({ url: 'api/getfacility_pending_all_periodical/'+id})
        .then(response => {
           // console.log(response.data);
          if(response.data.result.length>0)
          {
            dispatch(requestPendingPeriodicals(response.data.result))
          }
          else
          {
            dispatch(requestPendingPeriodicals([]))
          }
        })
        .catch(error => {
          if (error.response) 
						{
							if(error.response.status===403)
							{
								browserHistory.push('/');
								window.location.reload(); 
							}
							else
							{
								console.log(error);
							}
						}
        });
    }
  }


  function requestPendingPeriodicals(response) {
    return {
      type: RECEIVE_PENDING_PERIODICALS,
      pending_periodicals_data: response
    }
  }


  export function fetchPendingPeriodicalsList(id) {
    return (dispatch) => {
        return dispatch(fetchPendingPeriodicals(id))
    }
  }

  //* start //


  //start//

  function fetchSchedulePeriodicals(id,year) {
    return async dispatch => {
        return await getRequest({ url: 'api/getfacility_periodical_occurrence_details/'+year+'/'+id})
        .then(response => {
          //  console.log(response.data);
          if(response.data.result.length>0)
          {
            dispatch(requestSchedulePeriodicals(response.data.result))
          }
          else
          {
            dispatch(requestSchedulePeriodicals([]))
          }
        })
        .catch(error => {
          if (error.response) 
						{
							if(error.response.status===403)
							{
								browserHistory.push('/');
								window.location.reload(); 
							}
							else
							{
								console.log(error);
							}
						}
        });
    }
  }

  function requestSchedulePeriodicals(response) {
    return {
      type: RECEIVE_SCHEDULE_PERIODICALS,
      schedule_periodicals_data: response
    }
  }

  export function fetchSchedulingPeriodicalsList(id,year) 
  {
    return (dispatch) => {
        return dispatch(fetchSchedulePeriodicals(id,year))
    }
  }


    //end//


    // start//
    function pendingScheduleUpdate(post) {
      return async dispatch => {
          return await postRequest({ url: 'api/set_occurrence', payload: post})
          .then(response => {
              dispatch(pendingPeriodicalsUpdate(response.data))
          })
          .catch(error => {
            if (error.response) 
						{
							if(error.response.status===403)
							{
								browserHistory.push('/');
								window.location.reload(); 
							}
							else
							{
								console.log(error);
							}
						}
          });
      }
    }
  
    function pendingPeriodicalsUpdate(response) {
      return {
        type: PENDING_SCHEDULE_PERIODICALS_UPDATE,
        pending_periodicals_update: response
      }
    }
  
     export function periodicalsUpdate(post) {
      return (dispatch) => {
          return dispatch(pendingScheduleUpdate(post))
      }
    }
    //end//



     // start//
     function schedulePeriodicalsUpdateById(post) {
      return async dispatch => {
          return await putRequest({ url: 'api/update_occurrence', payload: post})
          .then(response => {
              dispatch(schedulePeriodicalsUpdate(response.data))
          })
          .catch(error => {
            if (error.response) 
						{
							if(error.response.status===403)
							{
								browserHistory.push('/');
								window.location.reload(); 
							}
							else
							{
								console.log(error);
							}
						}
          });
      }
    }
  
    function schedulePeriodicalsUpdate(response) {
      return {
        type: SCHEDULE_PERIODICALS_UPDATE,
        schedule_periodicals_update: response
      }
    }
  
     export function schedulePeriodicalUpdate(post) {
      return (dispatch) => {
          return dispatch(schedulePeriodicalsUpdateById(post))
      }
    }
    //end//

    // start revert set occurrence//
    function revertSetOccurrenceById(post) {
      return async dispatch => {
        return await postRequest({ url: 'api/revert_set_occurrence', payload: post})
        .then(response => {
          dispatch(schedulePeriodicalsUpdate(response.data))
        })
        .catch(error => {
        if (error.response) 
              {
                if(error.response.status===403)
                {
                  browserHistory.push('/');
                  window.location.reload(); 
                }
                else
                {
                  console.log(error);
                }
              }
        });
      }
    }
  
     export function revertSetOccurrence(post) {
      return (dispatch) => {
        return dispatch(revertSetOccurrenceById(post))
      }
    }

         // start on drag//
         function onDragPeriodicalsUpdate(post) {
          return async dispatch => {
              return await putRequest({ url: 'api/update_occurrence_data', payload: post})
              .then(response => {
                  dispatch(updateOnDrag(response.data))
              })
              .catch(error => {
                if (error.response) 
                {
                  if(error.response.status===403)
                  {
                    browserHistory.push('/');
                    window.location.reload(); 
                  }
                  else
                  {
                    console.log(error);
                  }
                }
              });
          }
        }
      
        function updateOnDrag(response) {
          return {
            type: DRAG_TO_MONTH,
            schedule_periodicals_update: response
          }
        }
      
         export function resetOnDrag(post) {
          return (dispatch) => {
              return dispatch(onDragPeriodicalsUpdate(post))
          }
        }
        //end//


// WEBPACK FOOTER //
// ./src/shared/actions/scheduling_action.js